import React from "react"
import { Layout } from "antd"
import styles from "./index.module.css"
import { Outlet } from "react-router-dom"
import { DigitalWaiverAndContractsBreadcrumb } from "./BreadCrumb"
// import { ClientsBreadcrumb } from "./Breadcrumb"
import classNames from "classnames"

export const ProDigitalWaiverAndContractsLayout = () => {
  return (
    <Layout className={classNames(styles.layout)}>
      <DigitalWaiverAndContractsBreadcrumb />
      <Outlet />
    </Layout>
  )
}
